<div class="page wpdh-page-wrapper">
  @if (isIEOrEdge) {
  <notification title="Warning" class="-colorAccentYellow">
    You are using an unsupported browser. Please switch to a modern browser such as Chrome, Firefox, or Safari for the
    intended experience.
  </notification>
  } @if (hasContent) {
  <div
    [ngClass]="
      meta?.type === 'Platforms'
        ? '-platforms-wrapper'
        : meta?.type === 'Enterprise'
        ? '-enterprise-wrapper'
        : meta?.type === 'Smb'
        ? '-smb-wrapper'
        : meta?.type === 'Payfac'
        ? '-payfac-wrapper'
        : meta?.type === 'Financial Institution'
        ? '-financial-institution-wrapper'
        : meta?.type === 'Independent Sales Org'
        ? '-independent-sales-organization-wrapper'
        : meta?.type === 'Independent Software Vendor'
        ? '-independent-software-vendor-wrapper'
        : meta.type === 'customerexperience'
        ? '-customerexperience-wrapper'
        : meta.type === 'allproduct'
        ? '-result-wrapper'
        : meta.type === 'marketplaces'
        ? '-marketplaces-wrapper'
        : ''
    ">
    @if (meta.template === globals.TEMPLATE_TYPES.REDOC) {
      <div class="-spec-page-wrapper">
        <app-redoc
          [body]="body"
          [categories]="categories"
          [pageRoute]="pageRoute"
          [routeRedocSubscription]="routeRedocSubscription">
        </app-redoc>
        <app-spec-footer></app-spec-footer>
      </div>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.PRODUCT) {
      <app-product
        [body]="body"
        [categories]="categories"
        [pageRoute]="pageRoute">
      </app-product>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.APIS_PAGE) {
      <apis
        [body]="body"
        [meta]="meta"
        [categories]="categories"
        [pageRoute]="pageRoute">
      </apis>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.PUBLIC
    || meta.template === globals.TEMPLATE_TYPES.CONTACT_PAGE
    || meta.template === globals.TEMPLATE_TYPES.PRODUCT_LANDING
    || meta.template === globals.TEMPLATE_TYPES.CATEGORY
    || meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW
    || meta.template === globals.TEMPLATE_TYPES.DOC_PAGE
    || meta.template === globals.TEMPLATE_TYPES.PROD_DOC_PAGE
    || meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE
    || meta.template === globals.TEMPLATE_TYPES.CONTACT_SALES) {
      <div class="-doc-page-wrapper">
        @if (meta.template !== globals.TEMPLATE_TYPES.PUBLIC && meta.template !== globals.TEMPLATE_TYPES.CONTACT_PAGE) {
          <left-nav
            class="-left-nav-container"
            [meta]="meta"
            [isSecNav]="isSecNav"
            [isSidebarPresent]="isSidebarPresent"
            [sidebarShow]="sidebarShow"
            [ngClass]="{
              '-left-nav-doc-container':
                meta.template === 'doc-page' ||
                meta.template === 'prod-doc-page' ||
                meta.template === 'article' ||
                meta.template === 'contact-sales',
              '-hide-sec-nav': !isSecNav,
              '-overlay-sec-nav': sidebarShow,
              '-hide-left-nav': meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE
            }"
            (sidebarEvent)="sidebarShowHandler($event)"></left-nav>
        }
        <div
          class="-content"
          [ngClass]="{
            '-product-content':
              meta.template === 'doc-page' ||
              meta.template === 'prod-doc-page' ||
              meta.template === 'article' ||
              meta.template === 'contact-sales',
            '-product-doc-content': meta.template === 'prod-doc-page',
            '-contact-content': meta.template === 'contact-page',
            '-product-landing-content': meta.template === 'product-landing',
            '-category-content': meta.template === 'category',
            '-contact-form-content': meta.type === 'form',
            '-hide-sec-nav': !isSecNav
          }"
          #content>
          <div
            class="-docpage-content-container"
            [ngClass]="{
              '-public-content-container': meta.template === 'public' && isDocIndex,
              '-add-secondary-nav':
                meta.template === (globals.TEMPLATE_TYPES.PRODUCT_LANDING || globals.TEMPLATE_TYPES.CATEGORY) && isSecNav,
              '-product-landing-container': meta.template === globals.TEMPLATE_TYPES.PRODUCT_LANDING,
              '-category-container': meta.template === globals.TEMPLATE_TYPES.CATEGORY,
              '-prod-doc-container': meta.template === globals.TEMPLATE_TYPES.PROD_DOC_PAGE,
              '-article-doc-container': meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE,
              '-contact-page-container': meta.template === globals.TEMPLATE_TYPES.CONTACT_PAGE,
              '-contact-page-form': meta.type === 'form',
              '-contact-sales-form': contactSales
            }">
            @if (meta.template === globals.TEMPLATE_TYPES.CONTACT_PAGE && !contactSales) {
            <app-contact-page [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute">
            </app-contact-page>
            } @if (meta.template === globals.TEMPLATE_TYPES.PUBLIC) {
            <app-public [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute"> </app-public>
            } @if (meta.template === globals.TEMPLATE_TYPES.PRODUCT_LANDING && !contactSales ) {
            <app-product-landing [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute">
            </app-product-landing>
            } @if (meta.template === globals.TEMPLATE_TYPES.CATEGORY && !contactSales ) {
            <app-category [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute"> </app-category>
            } @if (meta.template === globals.TEMPLATE_TYPES.API_OVERVIEW && !contactSales) {
            <app-api-overview [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute">
            </app-api-overview>
            } @if (meta.template === globals.TEMPLATE_TYPES.DOC_PAGE&& !contactSales ) {
            <app-doc [body]="body" [categories]="categories" [pageRoute]="pageRoute"> </app-doc>
            } @if (meta.template === globals.TEMPLATE_TYPES.ARTICLE_PAGE && !contactSales ) {
            <article-doc [body]="body" [categories]="categories" [pageRoute]="pageRoute"> </article-doc>
            } @if (meta.template === globals.TEMPLATE_TYPES.PROD_DOC_PAGE && !contactSales ) {
            <app-prod-doc [body]="body" [categories]="categories" [pageRoute]="pageRoute"> </app-prod-doc>
            } @if (contactSales) {
            <app-contact-sales
              [body]="body"
              [meta]="meta"
              [categories]="categories"
              [pageRoute]="pageRoute"></app-contact-sales>
            }
          </div>
        </div>
      </div>
    }
    @if (meta.template !== globals.TEMPLATE_TYPES.PUBLIC
      && meta.template !== globals.TEMPLATE_TYPES.PRODUCT
      && meta.template !== globals.TEMPLATE_TYPES.REDOC
      && meta.template !== globals.TEMPLATE_TYPES.APIS_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.PRODUCT_LANDING
      && meta.template !== globals.TEMPLATE_TYPES.CATEGORY
      && meta.template !== globals.TEMPLATE_TYPES.API_OVERVIEW
      && meta.template !== globals.TEMPLATE_TYPES.DOC_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.PROD_DOC_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.ARTICLE_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.HOMEPAGE
      && meta.template !== globals.TEMPLATE_TYPES.LEARNINGPAGE
      && meta.template !== globals.TEMPLATE_TYPES.CONTACT_PAGE
      && meta.template !== globals.TEMPLATE_TYPES.CONTACT_SALES
      && meta.template !== globals.TEMPLATE_TYPES.HOME
      && meta.template !== globals.TEMPLATE_TYPES.SEARCH_RESULT
      && meta.template !== globals.TEMPLATE_TYPES.BUSINESS_TYPE
      && meta.template !== globals.TEMPLATE_TYPES.ALL_PRODUCT) {
      <app-basic
        [body]="body"
        [meta]="meta"
        [categories]="categories"
        [pageRoute]="pageRoute">
      </app-basic>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.HOMEPAGE) {
      <app-homepage
        [body]="body"
        [meta]="meta"
        [categories]="categories"
        [pageRoute]="pageRoute">
      </app-homepage>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.HOME) {
      <app-home
        [body]="body"
        [meta]="meta"
        [categories]="categories"
        [pageRoute]="pageRoute">
      </app-home>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.BUSINESS_TYPE) {
      <app-business-type
        [body]="body"
        [meta]="meta"
        [categories]="categories"
        [pageRoute]="pageRoute">
      </app-business-type>
    }
    @if (meta.template === globals.TEMPLATE_TYPES.LEARNINGPAGE) {
    <app-learning-page [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute">
    </app-learning-page>
    } @if (meta.template === globals.TEMPLATE_TYPES.SEARCH_RESULT) {
    <app-search-results [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute">
    </app-search-results>
    } @if (meta.template === globals.TEMPLATE_TYPES.ALL_PRODUCT) {
    <app-all-product [body]="body" [meta]="meta" [categories]="categories" [pageRoute]="pageRoute"> </app-all-product>
    }
  </div>
  } @if (!hasContent) {
  <div>Content failed to load!</div>
  } @if (getapikeyInfoModal) {
  <div>
    <modal [visible]="true" (visibleChange)="closeInfoModal()" [secondaryModal]="true" [title]="'Not logged in !'">
      <div>
          <wpbutton type="submit" to="/account/login">Login</wpbutton>
          <wpbutton type="submit" to="/account/register">Create a free account</wpbutton>
      </div>
    </modal>
  </div>
  }
</div>
